import { GriddleStyleConfig } from 'griddle-react';
import * as React from 'react';


export const gridStyle: GriddleStyleConfig = {
    classNames: {
        Table: 'table table-striped',
        Filter: 'form-control',
        PageDropdown: 'form-control',
        PreviousButton: 'btn btn-primary prev-button',
        NextButton: 'btn btn-primary next-button'
    }
};

const ignoreEvent = (event: any) => {
    event.preventDefault();
    return false;
}

export const gridLayout = ({ Table, Pagination, Filter, SettingsWrapper }: any) => (
    <div className="datagrid">
        <form className="form-inline" onSubmit={ignoreEvent}>
            <div className="datagrid-controls-top">
                <Filter />
                <div className="pagination-container">
                    <Pagination />
                </div>
            </div>
        </form>
        <Table />
        <form className="form-inline" onSubmit={ignoreEvent}>
            <div className="datagrid-controls-bottom">
                <Pagination />
            </div>
        </form>
    </div>
);


// WEBPACK FOOTER //
// ./src/config/grid-config.tsx